/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
 useState,
 useEffect,
 InputHTMLAttributes,
} from 'react'
import {FieldValues, FieldErrors} from 'react-hook-form'
import {ErrorMessage} from '@hookform/error-message'
import {KTImage} from '../KTImage'

interface ToggleButtonFieldProps
 extends InputHTMLAttributes<HTMLInputElement> {
 id?: string
 name: string
 initialState?: boolean
 required?: boolean
 wrapperClassName?: string
 className?: string
 btnClassName?: string
 labelClassName?: string
 descClassName?: string
 iconPath?: string
 labelPosition?: string
 moveBtnToEnd?: boolean
 label?: string
 desc?: string
 register: FieldValues
 setValue: any
 watch: any
 errors?: FieldErrors | undefined
}

const ToggleButtonField: React.FC<
 ToggleButtonFieldProps
> = ({
 className,
 btnClassName,
 label,
 errors,
 register,
 setValue,
 watch,
 value,
 name,
 disabled = false,
 id,
 desc,
 required,
 wrapperClassName,
 descClassName,
 labelClassName,
 labelPosition = 'end',
 moveBtnToEnd = false,
 iconPath,
}) => {
 const [isOn, setIsOn] = useState(false)
 const watchedValue = watch(name)

 const handleToggle = () => {
  const newState = !isOn
  setIsOn(newState)
  setValue(name, newState, {shouldValidate: true})
 }

 useEffect(() => {
  setIsOn(watchedValue === true || watchedValue === 'true')
 }, [watchedValue])
 // eslint-disable-next-line no-console
 console.log('erros', errors)

 return (
  <div className={`${wrapperClassName}`}>
   <div className='relative flex items-center'>
    {iconPath && (
     <KTImage
      width={32}
      height={32}
      className={'flex items-center justify-center w-8 h-8'}
      src={iconPath}
      alt={''}
     />
    )}
    {labelPosition === 'start' && (
     <div className='text-[#33393D] text-lg font-medium ml-1'>
      {label}
      {required && (
       <span className='required-field pl-[2px]'>*</span>
      )}
     </div>
    )}
    <div
     className={`${
      moveBtnToEnd && 'ml-auto'
     } text-[#4E83E4] text-lg font-medium cursor-pointer`}
    >
     <button
      disabled={disabled}
      type='button'
      onClick={handleToggle}
      className={`${className} relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none ${
       isOn
        ? '!bg-indigo-600 translate-x-6.5'
        : 'bg-gray-200 translate-x-1'
      }`}
      role='switch'
      aria-checked={isOn}
     >
      <span
       className={`${btnClassName} inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ${
        isOn ? 'translate-x-6' : 'translate-x-1'
       }`}
      />
     </button>
    </div>
    {label && labelPosition === 'end' && (
     <div
      className={`${labelClassName} text-[#33393D] text-lg font-medium  ml-2`}
     >
      {label}
      {required && (
       <span className='required-field pl-[2px]'>*</span>
      )}
     </div>
    )}
   </div>
   {desc && (
    <div
     className={`${descClassName} text-[#33393D] text-xs font-medium mt-1`}
    >
     {desc}
    </div>
   )}
   <input
    name={name}
    id={id ?? name}
    className={`hidden`}
    value={value}
    {...register}
   />
   {errors && (
    <ErrorMessage
     errors={errors}
     name={name}
     render={({message}) => (
      <p className='error-msg error-cls'>{message}</p>
     )}
    />
   )}
  </div>
 )
}

export {ToggleButtonField}
